import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
	chipsContainer: {
		marginTop: theme.spacing(0.5),
		marginBottom: theme.spacing(1.5)
	},
	formControlContainer: {
		width: '100%' + theme.spacing(1),
		maxHeight: 200,
		paddingLeft: theme.spacing(1),
		marginLeft: -theme.spacing(1),
		overflowX: 'hidden',
		overflowY: 'auto'
	},
	formLabel: {
		marginBottom: theme.spacing(1)
	},
	radioRoot: {
		padding: 4,
		margin: '0 5px'
	}
}));
